
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import { Link } from "react-router-dom";
import { servicesData } from "@/components/services/servicesData";
import ServiceCard from "@/components/services/ServiceCard";
import AnimatedCard from "@/components/AnimatedCard";
import { ArrowRight } from "lucide-react";

const Services = () => {
  useEffect(() => {
    document.title = "AI Legal Services & Solutions | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Comprehensive AI consulting services for legal professionals. Strategy, training, custom workflows & advisory services. Start your transformation.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Comprehensive AI consulting services for legal professionals. Strategy, training, custom workflows & advisory services. Start your transformation.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <main className="pt-24 bg-background min-h-screen">
        <section className="px-6 py-16 relative">
          {/* Background image */}
          <div className="absolute inset-0 z-0">
            <img 
              src="/lovable-uploads/Nice_Demo.png"
              alt="Service demonstration"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-background/70 to-background/70"></div>
          </div>
          
          <div className="container mx-auto max-w-6xl relative z-10">
            <AnimatedCard animation="fade-in">
              <div className="text-center mb-12">
                <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight">
                  <span className="text-gradient">AI</span>{" "}
                  <span className="text-white">Consulting Services</span>
                </h1>
                
                <p className="text-lg md:text-xl text-foreground/80 max-w-3xl mx-auto">
                  Collaborate with our experts to revolutionize your legal practice through 
                  innovative AI-driven strategies and insights. Our comprehensive services 
                  are designed to transform how legal professionals work.
                </p>
              </div>
            </AnimatedCard>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
              {servicesData.slice(0, 4).map((service, index) => (
                <Link 
                  key={service.id} 
                  to={
                    service.title === "Strategy Consulting" 
                      ? "/services/strategy" 
                      : service.title === "Custom Workflows"
                        ? "/services/custom-solutions"
                        : `/services/${service.title.toLowerCase().replace(/\s+/g, '-')}`
                  }
                  className="block h-full transition-transform hover:scale-[1.02] duration-300"
                >
                  <ServiceCard 
                    title={service.title} 
                    description={service.description} 
                    icon={service.icon} 
                    color={service.color} 
                    delay={index * 100} 
                  />
                </Link>
              ))}
            </div>
            
            <div className="mt-16 text-center">
              <Link to="/contact" className="inline-flex items-center gap-2 text-primary hover:text-primary/90 transition-colors">
                <span className="text-lg font-medium">Get in touch to discuss your specific needs</span>
                <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </>
  );
};

export default Services;
